/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useContext, useState } from "react";
import { FirebaseContext } from "../context/FirebaseContext";
import { BarChart, PieChart, useDrawingArea } from "@mui/x-charts";
import { getDocs, collection } from "firebase/firestore";
import { styled } from "@mui/material/styles";
import Spinner from "../components/Spinner.component";
import { useMediaQuery } from "@mui/material";
const months = [
  "jan",
  "fev",
  "Mar",
  "Avr",
  "Mai",
  "Jui",
  "Juil",
  "Aou",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const StyledText = styled("text")(({ theme }) => ({
  fill: theme.palette.text.primary,
  textAnchor: "middle",
  dominantBaseline: "central",
  fontSize: 20,
  fontWeight: "bold",
}));

function PieCenterLabel({ match, children }) {
  const { width, height, left, top } = useDrawingArea();
  //const match1 = useMediaQuery("(max-width:450px)");
  return (
    <StyledText x={left + width / 2 - (match ? 110: 0)} y={top + height / 2}>
      {children}
    </StyledText>
  );
}

function Home() {
  const [userList, setListUser] = useState([]);
  const [statistic, setStatistic] = useState({});
  const [dataFullYear, setDataFullYear] = useState({});
  const [dataCurrentMonth, setDataCurrentMonth] = useState(Array(12).fill(0));
  const [loading, setLoading] = useState(true);
  const [numberActiveUser, setNumberActiveUser] = useState(0);
  const [numberTotalVisit, setNumberTotalVisit] = useState(0);

  const { db } = useContext(FirebaseContext);
  const visitPerYearRef = collection(db, "visitPerYear");
  const userListRef = collection(db, "visitorList");

  const matches = useMediaQuery("(max-width:500px)");
  function getSnapData(snapshot) {
    const data = [];
    snapshot.forEach((doc) => {
      data.push({
        [doc?.id]: doc?.data(),
      });
    });
    return data;
  }

  async function initStat(snapshot) {
    const newStatistic = { ...statistic };
    const currentYear = new Date().getFullYear();
    const newDataCurrentMonth = Array(months.length).fill(0);
    let newDataFullYear = {};
    snapshot.forEach((doc) => {
      for (const [key, value] of Object.entries(doc)) {
        const [day, month, year] = key.split(".");
        if (!newStatistic[year]) {
          newStatistic[year] = {};
        }
        newStatistic[year][month] =
          (newStatistic[year][month] || 0) + value.users.length;
        if (parseInt(year) === currentYear) {
          newDataCurrentMonth[parseInt(month) - 1] = newStatistic[year][month];
        }
      }
    });
    setStatistic(newStatistic);
    setDataCurrentMonth(newDataCurrentMonth);
    newDataFullYear = initDataFullYear(newStatistic, currentYear);
    setDataFullYear(newDataFullYear);
    setNumberTotalVisit(getFullVisitorNumber(newDataFullYear));
  }
  function initDataFullYear(stats, year) {
    let dataToTalViewPerYer = {};
    for (let i = year - 3; i < year + 3; i++) {
      if (!dataToTalViewPerYer[i]) {
        dataToTalViewPerYer[i] = 0;
      }
    }
    if (stats) {
      for (const [key, value] of Object.entries(stats)) {
        if (!dataToTalViewPerYer[key]) {
          dataToTalViewPerYer[key] = 0;
        }
        for (const [k, v] of Object.entries(value)) {
          dataToTalViewPerYer[key] = (dataToTalViewPerYer[key] || 0) + v;
        }
      }
    }
    return dataToTalViewPerYer;
  }

  function getFullVisitorNumber(dataYear) {
    let total = 0;
    for (const [k, v] of Object.entries(dataYear)) {
      total += v;
    }
    return total;
  }

  useEffect(() => {
    const querySnapshot = async () => {
      try {
        const snapshot = await getDocs(visitPerYearRef).then((snap) => {
          setLoading(false);
          return snap;
        });
        const data = getSnapData(snapshot);
        setStatistic({});
        initStat(data);
      } catch (error) {
        if (
          error
            .toString()
            .includes(
              "Could not reach Cloud Firestore backend. Backend didn't respond within 10 seconds."
            )
        ) {
          console.log(error);
        }
      }
    };
    return () => {
      querySnapshot();
    };
  }, []);

  useEffect(() => {
    const querySnapshot = async () => {
      try {
        const snapshot = await getDocs(userListRef);
        setListUser(getSnapData(snapshot));
      } catch (error) {
        if (
          error
            .toString()
            .includes(
              "Could not reach Cloud Firestore backend. Backend didn't respond within 10 seconds."
            )
        ) {
          console.log(error);
        }
      }
    };
    return () => {
      querySnapshot();
    };
  }, []);

  useEffect(() => {
    setNumberActiveUser(userList.length);
  }, [userList]);

  if (loading) {
    return <Spinner />;
  }
  return (
    <>
      <h1 className="title">TABLEAU DE BORD</h1>
      <hr />
      <div className="flex max-xl:flex-col w-full ">
        <div className="w-[45%] max-xl:w-full container__stat">
          <div className="text-xl stat__label">
            Nombre de visiteur : <span className="font-bold">{new Date().getFullYear()}</span>
          </div>
          <BarChart
            className="w-full"
            xAxis={[
              {
                id: "Vue total mois",
                data: months,
                scaleType: "band",
                label: "Mois",
              },
            ]}
            yAxis={[
              {
                label: "Visiteurs",
              },
            ]}
            series={[
              {
                data: dataCurrentMonth,
              },
            ]}
            height={200}
          />
        </div>
        <div className="w-[55%] max-xl:w-full">
          <PieChart
            className="w-full"
            series={[
              {
                data: [
                  {
                    id: 0,
                    value: numberActiveUser,
                    label: "Utilisateurs Actifs",
                  },
                  { id: 1, value: numberTotalVisit, label: "Visiteur total" },
                ],
                innerRadius: 60,
                outerRadius: 70,
                paddingAngle: 3,
                cornerRadius: 6,
                startAngle: -180,
                endAngle: 180,
                cx: matches ? 70 : undefined,
              },
            ]}
            height={250}
          >
            <PieCenterLabel match={matches}>
              {numberActiveUser}/{numberTotalVisit}
            </PieCenterLabel>
          </PieChart>
        </div>
      </div>
      <div className="my-4 container__stat">
        <BarChart
          xAxis={[
            {
              id: "Vue total year",
              data: [...Object.keys(dataFullYear)],
              scaleType: "band",
              label: "  Annee",
            },
          ]}
          yAxis={[
            {
              label: "Visiteurs",
            },
          ]}
          series={[
            {
              data: [...Object.values(dataFullYear)],
            },
          ]}
          height={200}
        />
      </div>
    </>
  );
}

export default Home;
